import React from "react";
import PropTypes from 'prop-types';
import WorkflowStatus from "../../Util/WorkflowStatus";
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';

const Workflow = ({workflowStatus}) => (
    <div className='media-body'>
        <p>
            <FormattedMessage id="thread.workflow_changed"/>: &nbsp;<WorkflowStatus status={workflowStatus}/>
        </p>
    </div>
);

Workflow.propTypes = {
    workflowStatus: PropTypes.any.isRequired
};

export default connect(
    (state, props) => ({
        workflowStatus: state.getIn(['workflowStatuses', props.workflowStatus])
    })
)(Workflow);
